module.exports = __webpack_public_path__ + "static/img/10.b2f9fd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/10.png
// module id = IJie
// module chunks = 0